export default __webpack_public_path__ + "static/media/harley.3ba4f015.jpg";